import { TestDeviceComponent } from './test-device/test-device.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/components';

// route guard
import { AuthGuard } from '@core/index';
import { LaneClosedComponent } from './lane-closed/lane-closed.component';
import { StoreIdGuard } from '@core/guards/store-id.guard';
import { ErrorStoreIdMissingComponent } from './error-storeid-missing/error-storeid-missing.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'authenticate',
    loadChildren: () => import('./authenticate-dmb/authenticate-dmb.module').then((m) => m.AuthenticateDMBModule),
    canActivate: [StoreIdGuard],
  },
  {
    path: 'order-conversation',
    loadChildren: () => import('./order-conversation/order-conversation.module').then((m) => m.OrderConversationModule),
    data: { animationState: 'One' },
    canActivate: [AuthGuard, StoreIdGuard],
  },
  {
    path: 'start-conversation',
    loadChildren: () => import('./start-conversation/start-conversation.module').then((m) => m.StartConversationModule),
    data: { animationState: 'Three' },
    canActivate: [AuthGuard, StoreIdGuard],
  },
  {
    path: 'sign-out',
    loadChildren: () => import('./sign-out/sign-out.module').then((m) => m.SignOutModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'end-conversation',
    loadChildren: () => import('./end-conversation/end-conversation.module').then((m) => m.EndConversationModule),
    canActivate: [AuthGuard, StoreIdGuard],
    data: { animationState: 'Two' },
  },
  {
    path: 'lane-closed',
    component: LaneClosedComponent,
    canActivate: [StoreIdGuard],
  },
  {
    path: 'error-storeid-missing',
    component: ErrorStoreIdMissingComponent,
  },
  { path: 'test-device', component: TestDeviceComponent },
  { path: '', redirectTo: '/start-conversation', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
